/**
 * Internal dependencies
 */
import edit from "./edit";
import metadata from "./block.json";

/**
 * WordPress dependencies
 */
import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";

/**
 * Block constants
 */
const { name, category } = metadata;

const settings = {
	/* translators: block name */
	title: __("Navigation Menu", "a3web-blocks"),
	/* translators: block description */
	description: __(
		"Display a navigation menu.",
		"a3web-blocks"
	),
	icon: "menu",
	keywords: [
		"a3web-blocks",
		/* translators: block keyword */
		__("menu", "a3web-blocks"),
		/* translators: block keyword */
		__("navigation", "a3web-blocks"),
	],
	supports: {
		align: ["wide", "full"],
		html: false,
	},
	edit,
	save() {
		return null;
	},
};

/**
 *Register the block.
 */
registerBlockType(name, {
	category,
	...settings,
});
